// third-party
import { presetPalettes, presetDarkPalettes } from '@ant-design/colors';

// project imports
import ThemeOption from './theme';
import { extendPaletteWithChannels } from 'utils/colorUtils';

const greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];

// ==============================|| GREY COLORS BUILDER ||============================== //

function buildGrey(isDark) {
  let greyPrimary = [
    '#ffffff', // 0
    '#fafafa', // 50
    '#f5f5f5', // 100
    '#f0f0f0', // 200
    '#d9d9d9', // 300
    '#bfbfbf', // 400
    '#8c8c8c', // 500
    '#595959', // 600
    '#262626', // 700
    '#141414', // 800
    '#000000'  // 900
  ];
  if (isDark) {
    greyPrimary = [
      '#000000', // 0 -> 900
      '#141414', // 50 -> 800
      '#1f1f1f', // 100 -> 700
      '#262626', // 200 -> 600
      '#434343', // 300 -> 500
      '#595959', // 400 -> 400
      '#8c8c8c', // 500 -> 300
      '#bfbfbf', // 600 -> 200
      '#d9d9d9', // 700 -> 100
      '#f0f0f0', // 800 -> 50
      '#ffffff'  // 900 -> 0
    ];
  }
  let greyConstant = isDark ? ['#1f1f1f', '#141414'] : ['#fafafb', '#e6ebf1'];
  let greyAscentDark = ['#1f1f1f', '#434343', '#bfbfbf', '#fafafa'];
  let greyAscentLight = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];

  return [...greyPrimary, ...(isDark ? greyAscentDark : greyAscentLight), ...greyConstant];
}

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette(presetColor) {
  const lightColors = { ...presetPalettes, grey: buildGrey(false) };
  const lightPaletteColor = ThemeOption(lightColors, presetColor);

  const darkColors = { ...presetDarkPalettes, grey: buildGrey(true) };
  const darkPaletteColor = ThemeOption(darkColors, presetColor);
  
  // Invert primary colors for dark mode if needed, but for now let's keep them
  // Ant Design primary colors usually work okay in dark mode if the backgrounds are right.

  const commonColor = { common: { black: '#000', white: '#fff' } };

  const extendedLight = extendPaletteWithChannels(lightPaletteColor);
  const extendedDark = extendPaletteWithChannels(darkPaletteColor);
  const extendedCommon = extendPaletteWithChannels(commonColor);

  return {
    light: {
      mode: 'light',
      ...extendedCommon,
      ...extendedLight,
      text: {
        primary: extendedLight.grey[700],
        secondary: extendedLight.grey[500],
        disabled: extendedLight.grey[400]
      },
      action: { disabled: extendedLight.grey[300] },
      divider: extendedLight.grey[200],
      background: {
        paper: extendedLight.grey[0],
        default: extendedLight.grey.A50
      }
    },
    dark: {
      mode: 'dark',
      ...extendedCommon,
      ...extendedDark,
      text: {
        primary: '#ffffff',
        secondary: '#bfbfbf',
        disabled: '#8c8c8c'
      },
      action: { disabled: '#595959' },
      divider: '#262626',
      background: {
        paper: '#1e1e1e',
        default: '#121212'
      }
    }
  };
}
